const HelpSqaureIcon = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M1.77075 8.9987C1.77075 5.82654 1.77075 4.24046 2.75622 3.25499C3.74168 2.26953 5.32776 2.26953 8.49992 2.26953C11.6721 2.26953 13.2582 2.26953 14.2436 3.25499C15.2291 4.24046 15.2291 5.82654 15.2291 8.9987C15.2291 12.1709 15.2291 13.7569 14.2436 14.7424C13.2582 15.7279 11.6721 15.7279 8.49992 15.7279C5.32776 15.7279 3.74168 15.7279 2.75622 14.7424C1.77075 13.7569 1.77075 12.1709 1.77075 8.9987Z"
        stroke="white"
      />
      <path
        d="M7.08325 6.8737C7.08325 6.09129 7.71752 5.45703 8.49992 5.45703C9.28232 5.45703 9.91659 6.09129 9.91659 6.8737C9.91659 7.15572 9.83418 7.4185 9.69212 7.63926C9.26875 8.29722 8.49992 8.92463 8.49992 9.70703V10.0612"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M8.49425 12.543H8.50061"
        stroke="white"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HelpSqaureIcon;
